import Fade from "@mui/material/Fade";
import PropTypes from "prop-types";
import { useSnapshot } from "valtio";

import React from "react";
import { useTranslation } from "react-i18next";
import { shallowEqual, useSelector } from "react-redux";

import useIsInViewport from "@components/OrderTaking/Components/Products/ProductWrapper/hooks/useIsInViewport";
import {
    memoizedActiveCategoryUid,
    memoizedOrderItems,
} from "@components/OrderTaking/Store/feature";
import { initialState } from "@components/OrderTaking/Store/feature/orderWorkflowItemSlice";

import { kioskStore } from "@pages/Kiosk/store";

import { AnimatesProducts } from "./AnimatesProducts";
// eslint-disable-next-line
import { ResponsiveItemsList } from "./component";
import { getVisibleItems } from "./hooks";
import "./index.css";
import { ShopCartHeight } from "./ShopCartHeight";

export function ListItems({
    listProducts,
    currentWorkflow,
    isAdditionalSale = false,
    listAdditionnalItems,
    isWorkFlow,
    workflowData = [],
    orderWorkflowItemSlice = initialState,
}) {
    const scrollableParentRef = React.useRef(null);
    const lastElementRef = React.useRef(null);

    const { t } = useTranslation();

    const { isPrm, selectedSaleModeOrderTaking } = useSnapshot(kioskStore);

    const activeCategory = useSelector((state) =>
        memoizedActiveCategoryUid(state)
    );

    const orderItems = useSelector((state) => memoizedOrderItems(state));

    const { design } = useSelector((state) => state.orderSlice, shallowEqual);

    const { additionalSale } = useSelector(
        (state) => state.orderSlice,
        shallowEqual
    );
    const { visibleItems, gridSystem } = getVisibleItems(
        listProducts,
        listAdditionnalItems,
        activeCategory,
        selectedSaleModeOrderTaking,
        isWorkFlow,
        currentWorkflow,
        isAdditionalSale,
        additionalSale,
        design
    );

    // detect if element display on viewport
    const isScrollIconHidden = useIsInViewport(
        lastElementRef,
        visibleItems,
        scrollableParentRef
    );

    const { nbrColumn, nbrRows } = gridSystem;
    let nbItem = nbrColumn * nbrRows;

    const keySlide =
        listProducts !== undefined ? listProducts.length : activeCategory;
    const isSlideAnimationEnter =
        currentWorkflow || listAdditionnalItems ? 0 : 200;

    return (
        <div
            className="d-flex scrollbarY justify-content-center h-100 w-100"
            ref={scrollableParentRef}
        >
            {currentWorkflow ? (
                <AnimatesProducts>
                    <div
                        style={{
                            width: currentWorkflow && !isPrm && "860px",
                            height: "100%",
                        }}
                    >
                        <div
                            className={`row w-100 my-1 h-100 ${
                                visibleItems.length <= 3 && ""
                            } ${
                                visibleItems.length === 3
                                    ? "initialFlexDirection "
                                    : ""
                            }`}
                            style={{
                                marginLeft: "unset",
                                marginRight: "unset",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%",
                            }}
                        >
                            <ResponsiveItemsList
                                scrollableParentRef={scrollableParentRef}
                                lastElementRef={lastElementRef}
                                visibleItems={visibleItems}
                                currentWorkflow={currentWorkflow}
                                orderItems={orderItems}
                                isWorkFlow={isWorkFlow}
                                gridSystem={gridSystem}
                                workflowData={workflowData}
                                orderWorkflowItemSlice={orderWorkflowItemSlice}
                            />
                        </div>
                        <ShopCartHeight />
                    </div>
                </AnimatesProducts>
            ) : (
                <Fade
                    in={true}
                    key={keySlide}
                    unmountOnExit
                    style={{
                        transformOrigin: "0 0 0 ",
                        width: currentWorkflow && !isPrm && "860px",
                    }}
                    timeout={{
                        appear: 0,
                        enter: isSlideAnimationEnter,
                        exit: 100,
                    }}
                    direction="up"
                >
                    <div
                        className={`row w-100 my-1  ${
                            visibleItems.length <= 3 && ""
                        } ${
                            visibleItems.length === 3
                                ? "initialFlexDirection"
                                : ""
                        }`}
                        style={{
                            marginLeft: "unset",
                            marginRight: "unset",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <ResponsiveItemsList
                            scrollableParentRef={scrollableParentRef}
                            lastElementRef={lastElementRef}
                            visibleItems={visibleItems}
                            currentWorkflow={currentWorkflow}
                            orderItems={orderItems}
                            isWorkFlow={isWorkFlow}
                            gridSystem={gridSystem}
                            workflowData={workflowData}
                            orderWorkflowItemSlice={orderWorkflowItemSlice}
                        />
                    </div>
                </Fade>
            )}
            {!isScrollIconHidden && nbItem < visibleItems.length ? (
                <button
                    className="d-flex flex-column"
                    style={{
                        border: "none",
                        background: "none",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "absolute",
                        right: "4px",
                        bottom: currentWorkflow ? "6%" : "12%",
                        zIndex: "100",
                    }}
                    onClick={() => {
                        lastElementRef.current &&
                            lastElementRef.current.scrollIntoView(true, {
                                behavior: "smooth",
                            });
                    }}
                >
                    <div
                        className="chevron"
                        style={{
                            position: "sticky",
                            bottom: "2%",
                        }}
                    ></div>
                    <div
                        className="chevron"
                        style={{
                            position: "sticky",
                            bottom: "2%",
                        }}
                    ></div>
                    <div
                        className="chevron"
                        style={{
                            position: "sticky",
                            bottom: "2%",
                        }}
                    ></div>
                    <span className="text">{t("Scroll")}</span>
                </button>
            ) : null}
        </div>
    );
}

ListItems.propTypes = {
    listProducts: PropTypes.array,
    currentWorkflow: PropTypes.object,
    isAdditionalSale: PropTypes.bool,
    isWorkFlow: PropTypes.bool,
    listAdditionnalItems: PropTypes.array,
    workflowData: PropTypes.array,
    orderWorkflowItemSlice: PropTypes.object,
};
